import React from "react";
import MAddOnPurchaseProductCard from "./MAddOnPurchaseProductCard";
import type { AddOnPurchaseListProps } from "../../activity/add-on-purchase/types";

const MAddOnPurchaseProductList: React.FC<AddOnPurchaseListProps> = ({ products, ...cardProps }) => (
  <div className="productList">
    {products.map((product) => (
      <MAddOnPurchaseProductCard key={`${product.category || ""}_${product.sku}`} product={product} {...cardProps} />
    ))}
  </div>
);
export default MAddOnPurchaseProductList;
